<template>
  <div class="pausa-web">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <h4 class="client">AnimaEdu</h4>
          <h1 class="title">
            {{ $t("pausaWeb.title") }}
          </h1>
          <p class="date">
            {{ $t("pausaWeb.duration.title") }}
            {{ $t("pausaWeb.duration.date") }}
          </p>
          <p class="role">
            {{ $t("pausaWeb.position.title") }}
            {{ $t("pausaWeb.position.role") }}
          </p>
          <p class="description">
            {{ $t("pausaWeb.description") }}
          </p>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img src="@/assets/pausaweb.png" alt="" class="demo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PausaWeb",
  components: {},
};
</script>
<style lang="scss" scoped>
div.pausa-web {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 0;

  @media (min-width: 600px) {
    height: 100vh;
    padding: 0;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      color: gray;
      font-weight: bold;
      // font-family: "Raleway";
    }

    h1.title {
      //color: #fff;
      font-family: "Raleway";
    }

    p.description {
      text-align: left;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #000;
      font-size: 1.2rem;
    }
  }

  div.multimedia-container {
    img {
      width: 85%;
      box-shadow: 3px 3px 38px 7px #000;
    }
  }
}
</style>
